import React, { useContext } from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
//import {  InCart } from '../../../Context';
//import store from '../../utils/store/store';
import { CartState } from '../../../Context';
const Cart = () => {
  const {
    state: { cart },
    dispatch,
  } = CartState();
   //const cau=useSelector((store)=>store.cart.items);
   //IMP:2:35:33 (INTERVIEW)
   
   //console.log("CART"+cau)
  
   
  
  
  return (
    <>
    <div>
    
      {
         Object.values(cart).map((idx,ele)=>(
         
          <div>
          <h3 key={ele}>{idx.card.info.name +" : "+idx.card.info.price}</h3>
         
          </div>
        ))
      }
  
    </div>
    </>
  )
}

export default Cart